<template>
  <el-aside class="drawer-nav">
  <!-- Admin Menu -->
  <el-menu v-if="userIsAdmin" @select="handleSelect">

    <router-link to="/lista-de-analisis" class="nav-header">
      <img src="/static/menu.svg">
      <img src="/static/logo.svg" class="header-logo">
    </router-link>
    <el-menu-item index="/links" class="nav-link"><i class="el-icon-share"></i>Tablero de control</el-menu-item>
    <el-menu-item index="/lista-de-analisis" class="nav-link"><i class="el-icon-document"></i>Análisis de portafolios</el-menu-item>
    <el-menu-item index="/validacion" class="nav-link"><i class="el-icon-check"></i>Validación</el-menu-item>
    <el-menu-item index="/calculadora" class="nav-link"><i class="el-icon-plus"></i>Calculadoras</el-menu-item>
    <el-menu-item index="/lista-de-asesores" class="nav-link">Asesores</el-menu-item>

    <!-- <el-menu-item index="/archivos" class="nav-link"><i class="el-icon-upload2"></i>Archivos</el-menu-item> -->
    <el-menu-item index="/login">Cerrar sesión</el-menu-item>
  </el-menu>
  <!-- Advisor Menu -->
  <el-menu v-else @select="handleSelect">

    <router-link to="/lista-de-analisis" class="nav-header">
    <img src="/static/menu.svg">
    <img src="/static/logo.svg" class="header-logo">
    </router-link>
    <el-menu-item index="/links" class="nav-link"><i class="el-icon-share"></i>Tablero de control</el-menu-item>
    <el-menu-item index="/lista-de-analisis" class="nav-link"><i class="el-icon-document"></i>Análisis de portafolios</el-menu-item>
    <el-menu-item index="/validacion" class="nav-link"><i class="el-icon-check"></i>Validación</el-menu-item>
    <el-menu-item index="/calculadora" class="nav-link"><i class="el-icon-plus"></i>Calculadoras</el-menu-item>
    <el-menu-item index="/login">Cerrar sesión</el-menu-item>
  </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'NavBar',
  computed: {
    userIsAdmin: function () {
      return this.$store.getters.userIsAdmin
    }
  },
  methods: {
    handleSelect (key) {
      this.$store.dispatch( 'toggleMenu' , false )
      if (key !== '/login') {
        this.$router.push(key)
      } else {
        // logout user
        localStorage.removeItem('token')
        localStorage.removeItem('user_id')
        this.$store.dispatch( 'deleteUserData')
        this.$router.push('/')
      }
    },
  }
};
</script>

<!-- Component styles if required -->
<style scoped>
  .nav-header {
    border-bottom: 1px solid #001F5C;
    margin: 0 20px;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
  }

  .nav-link {
    color: #303133;
    text-decoration: none;
  }

  .el-menu-item {
    font-size: 16px;
    font-weight: 500;
    margin: 11px;
    height: 40px;
    line-height: 40px;
  }

  .el-menu-item:hover {
    background-color:  #E3ECFF;
  }

  .is-active {
    background-color: #E3ECFF;
    color: #001F5C;
  }

  .el-aside {
    background-color: white;
    z-index: 100;
    position: absolute;
    top: 0;
    height: 100%;
  }

  .drawer-nav {
    transition: .3s all;
    background-color: white;
    position: fixed;
    height: 100vh;
    transform: translateX(-100%);
    z-index: 10000;
    width: 100%;
    top: 0;
    left: 0;
    text-align: left;
  }

  .drawer-nav .el-menu {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue